/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const WorkOrderMaterialAvailabilityStatusService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/WorkOrderMaterialAvailabilityStatus",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url,params) {
    return {
      filter: params.filter,
      sort: params.sort,
      expand: params.expand,
      store: {
        type: "odata",
        key: "Code",
        version: 4,
        url: url,
        beforeSend: function(request) {
          request.headers[
            "Authorization"
          ] = `Bearer ${TokenStorage.getToken()}`;
          request.headers["Content-Type"] = "application/json";
          request.headers["x-tenant-id"] = TokenStorage.getTenant();
        },
      },

      select: params.select,
    };
  },
  async save(workOrderMaterialAvailabilityStatus) {
    var payload = workOrderMaterialAvailabilityStatus;
    var url = "api/WorkOrderMaterialAvailabilityStatus";

    return await ApiService.patch(
      url,
      workOrderMaterialAvailabilityStatus.Code,
      payload,
      "String"
    );
  },
};

export { WorkOrderMaterialAvailabilityStatusService };
